import { CasesTableProvider } from '@/pages/dashboard/cases/contexts'
import { CasesTable } from '@/pages/dashboard/ui/cases/cases-table/cases-table'
import { DeleteCasesButton } from '@/pages/dashboard/ui/cases/delete-cases-button/delete-cases-button'
import { TableLoading } from '@/pages/dashboard/ui/table/table-loading/table-loading'

import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { CASE_TABLE_TABS, CASE_TABLE_TAB_MAP } from './constants'
import { useApplicantCases } from './use-applicant-cases'

export interface ApplicantCasesProps {
  currentCategoryTab: string
}

export const ApplicantCases = ({ currentCategoryTab }: ApplicantCasesProps) => {
  const {
    filteredCases,
    selection,
    sortKey,
    sortOrder,
    currentCaseTableTab,
    isEveryRowSelected,
    isLoadingCases,
    handleToggleCaseRowSelection,
    handleToggleAllRowSelection,
    handleSortChange,
    handleChangeCaseTableTab,
  } = useApplicantCases({
    currentCategoryTab,
  })

  return (
    <>
      <div className={cn('flex justify-end', 'my-4')}>
        <DeleteCasesButton disabled={selection.length === 0} caseIds={selection} />
      </div>

      {isLoadingCases ? (
        <TableLoading />
      ) : (
        <>
          <Tabs
            className={cn('px-3 py-0.5', 'bg-muted', 'rounded-tl-md rounded-tr-md')}
            value={currentCaseTableTab}
            onValueChange={handleChangeCaseTableTab}
          >
            <TabsList>
              {CASE_TABLE_TABS.map(({ label, value }, index) => (
                <TabsTrigger key={`${value}-${index}`} value={value}>
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
          <CasesTableProvider
            value={{
              tableType: currentCaseTableTab === CASE_TABLE_TAB_MAP.ACTIVE ? 'active' : 'inactive',
            }}
          >
            <CasesTable
              className={cn('rounded-tl-none rounded-tr-none')}
              cases={filteredCases ?? []}
              selectedCaseIds={selection}
              currentSort={{ key: sortKey, order: sortOrder }}
              isEveryRowSelected={isEveryRowSelected}
              onToggleCaseRowSelection={handleToggleCaseRowSelection}
              onToggleAllRowSelection={handleToggleAllRowSelection}
              onSortChange={handleSortChange}
            />
          </CasesTableProvider>
        </>
      )}
    </>
  )
}
